import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectNotFoundRoute: InvariantJiraRoute = {
	name: 'project-not-found',
	path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
	query: ['projectKey?'],
	exact: true,
};
